// extracted by css-extract-rspack-plugin
export default {"sectionHeader":"_d73105cb"};